// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2eq6O","box":"WorkspacesBox_box__3Nvmf","node":"WorkspacesBox_node__3ihz2"};